import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';


export default function PlacesScreen(){
    const [country, setCountry] = useState("");
    const [countryList, setCountryList] = useState([]);
    const adminSignin = useSelector((state) => state.adminSignin);
    const { adminInfo } = adminSignin;
    const navigate = useNavigate();

    useEffect(() => {
            const fetchCountry = async () => {
                try {
                    const response = await axios.get('/api/admin/optrip/country', {
                        headers: {
                            Authorization: `Bearer ${adminInfo.token}`,
                        },
                    });
                    if (response.status !== 200) {
                        throw new Error('Failed to fetch countries');
                    }
                    setCountryList(response.data);
                } catch (error) {
                    console.error('Error fetching countries:', error);
                }
            };
            fetchCountry();
        }, [adminInfo.token]);

    useEffect(()=> {
        if(!adminInfo){
            navigate("/signin");
        }
    },[adminInfo,navigate]);
    const scrapeNow = async (path) => {
            try {
                const response = await axios.get(`https://optrip.workingfromhammock.com/${path}?country=` + country);
                if (response.status !== 200) {
                    console.error('Error scraping data:', response);
                    alert('Error scraping data');
                    return;
                }
                console.log(response.data.message);
                alert(response.data.message);
                // Optionally, you can update the status or other fields after scraping
            } catch (error) {
                console.error('Error scraping data:', error);
                alert('Error scraping data');
            }
        };

    return(
         <div className='row'>
            <div className='button-container col-lg-6 col-md-8 col-sm-10 col-xs-12 mt-10 pt-10 ' >
                {adminInfo.role_edit ? <div className='dis-button ' >
                    <select  value={country} onChange={(e) => setCountry(e.target.value)}>
                        <option value="">Select A Country</option>
                        {countryList.map((country, index) => (
                            <option key={index} value={country.country}>
                                {country.country}
                            </option>
                        ))}
                    </select>
                </div> : <></>}
                {adminInfo.role_edit ?<div className='dis-button' >
                    <button className='button' onClick={() => {scrapeNow('googlemaps')}}> Collect Google Places </button>
                </div> : <></>}
                {adminInfo.role_edit ?<div >
                    <button className='button' onClick={() => {scrapeNow('distance')}}> Calculate Distance </button>
                </div> : <></>}
                
          </div>
        </div>
    );
}